module.exports = __webpack_public_path__ + "static/img/Security-2FA.fd52fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/backoffice/Security-2FA.png
// module id = XFTY
// module chunks = 0